import type { RetrievalMetadataItemsResponse } from "@/services/metadata_v1/types";

export interface FileOption {
  value: string;
  label: string;
}

export function mapFileEdgesToOptions(data: RetrievalMetadataItemsResponse): FileOption[] {
  return data.edges.flatMap((edge) =>
    edge.node.items.map((item) => ({
      value: item.id,
      label: item.fileName ?? item.fullName,
    }))
  );
}
